import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TTicketAutoFinishRuleForm } from "./TicketAutoFinishRuleSchema";
import { useEffect, useRef, useState } from "react";
import { ticketChannelStep } from "../../../../../../services/ticketChannelStep.service";

const translationPath = "page.settings.crm.ticketAutoFinishRules.";

const TicketChannelStep = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<TTicketAutoFinishRuleForm>();

  const [ticketChannelSteps, setTicketChannelSteps] = useState<ISelectType[]>(
    [],
  );
  const lastFetchedTicketChannelId = useRef<string | null>(null);

  const { sendRequest } = useFetch(ticketChannelStep);

  const ticketChannel = useWatch({
    name: "ticketChannel",
    control,
  });

  useEffect(() => {
    if (!ticketChannel?.id) {
      lastFetchedTicketChannelId.current = null;
      setTicketChannelSteps([]);
      return;
    }

    if (lastFetchedTicketChannelId.current === ticketChannel.id) {
      return;
    }

    lastFetchedTicketChannelId.current = ticketChannel.id;

    const fetchTicketChannelSteps = async () => {
      const { data, success } = await sendRequest({
        id: ticketChannel.id,
        notFinish: true,
      });
      if (data && success) {
        setTicketChannelSteps(data);
      }
    };

    fetchTicketChannelSteps();
  }, [sendRequest, ticketChannel]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        getOptionLabel={(option) => {
          return option.name;
        }}
        size="small"
        label={t(translationPath + "ticket_channel_step")}
        name="ticketChannelStep"
        options={ticketChannelSteps}
      />
    </Grid>
  );
};

export default TicketChannelStep;
